import styled from "styled-components";

export const Label = styled.label`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid transparent;
  padding: 10px;
  cursor: pointer;
  border-radius: 10px;
  transition: all ease-in-out 0.3s;

  &:hover {
    background-color: var(--theme-color-tertiary);
    border-color: var(--border-color);
  }

  input {
    padding: 0;
    margin: 0;
  }

  span {
    font-size: 12px;
  }
`;